<template>
    <div>
        <div class="cabinet-text">
            <p>Создайте отложенное письмо для ваших самых близких людей. Мы удостоверимся, что оно будет отправлено всем
                указанным адресатам только после наступления вашей смерти. Процесс создания и отправки письма выглядит
                так:</p>
            <ol>
                <li>Вам нужно заполнить свой номер телефона на странице
                    <router-link :to="{name: 'ClientProfile'}">«Профиль»</router-link>
                    и данные контактных лиц на странице
                    <router-link :to="{name: 'ClientContacts'}">«Контактные лица»</router-link>
                    .
                </li>
                <li>Сразу после этого вы можете создать письмо.</li>
                <li>После написания письма вы оформляете подписку, и каждый месяц по нему поступает абонентская плата.
                    Очень важно, чтобы при оформлении подписки вы указали карту, которая принадлежит именно вам.
                    Когда Банк-эмитент узнает о смене статуса своего клиента (узнает он моментально, так как смену статуса гражданина проводят сотрудники полиции или скорой помощи в базе МВД России), Банк блокирует все счета, принадлежащие своему клиенту.
                    В этом случае, даже если на счете есть деньги, их списание будет невозможно.
                </li>
                <li>Если в дату очередного списания оплата не пройдет, мы попробуем с вами связаться каждым из указанных
                    вами способов. Поэтому, пожалуйста, заполните как можно больше контактных данных в своем
                    <router-link :to="{name: 'ClientProfile'}">профиле</router-link>
                    .
                </li>
                <li>Если нам удастся с вами связаться, то мы напомним о необходимости возобновить подписку.</li>
                <li>Если же нам не удастся связаться с вами, то мы попробуем связаться с
                    <router-link :to="{name: 'ClientContacts'}">контактными лицами</router-link>
                    , указанными вами. Для создания письма вам необходимо указать их данные.
                </li>
                <li>Только в случае подтверждения вашей смерти контактными лицами мы отправим все ваши письма указанным
                    адресатам.
                </li>
            </ol>
        </div>

        <router-link class=button-new-mail-content button-new-mail-no-data :to="{name: 'MailCreate'}">
            <span class="text">
                <span class="icon"><PlusIcon/></span>
                Создать новое отложенное письмо
            </span>
        </router-link>
    </div>
</template>

<script>
import PlusIcon from "@/components/icons/PlusIcon";
export default {
    name: "MailsNoData",
    components: {PlusIcon}
}
</script>

<style scoped>

</style>